/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { AssignConfigurationsToSuite } from "TestManagement/Scripts/TFS.TestManagement.AssignConfigurationsToSuite";

export interface IAssignConfigDialogProps {
    planId: number;
    suite: any;
    dialogType: string;
    testCaseIds?: number[];
    onSuccess: () => void;
}

// This is a proxy component to load the assign configuration dialog in the new web platform using LegacyComponent
class AssignConfigDialogProxy extends React.Component<IAssignConfigDialogProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let assignConfigurationsToSuite: AssignConfigurationsToSuite = new AssignConfigurationsToSuite(this.props.planId, this.props.suite);
        if (this.props.dialogType === "AssignConfigToSuite") {
            assignConfigurationsToSuite.AssignConfigurations((assignedConfigurations: number[], changesSaved: boolean) => {
                if (changesSaved) {
                    this.props.onSuccess();
                }
            }, null);
        } else if (this.props.dialogType === "AssignConfigToTestCases") {
            let testCaseAndSuiteList = [];
            for (let i = 0; i < this.props.testCaseIds.length; i++) {
                testCaseAndSuiteList.push({
                    id: this.props.testCaseIds[i],
                    suiteId: this.props.suite.id
                });
            }
            assignConfigurationsToSuite.AssignConfigurationsToTestCases(
                testCaseAndSuiteList,
                null,
                (assignedConfigurations: number[], changesSaved: boolean) => {
                    if (changesSaved) {
                        this.props.onSuccess();
                    }
                },
                null
            );
        }
    }
}

registerLWPComponent("assign-config-dialog-proxy", AssignConfigDialogProxy);
